export const ERMPortalUrls = {
    base: '/',
    // Needed by topbar for account dropdown
    logout: '/Login',
    // Needed by Topbar for external links
    conductDeclarations: 'https://kye.standardbank.co.za/',
    myAccess: 'https://myaccess.standardbank.co.za/identityiq/home.jsf',
    technicalSupport:
        'https://itsmweb.standardbank.co.za/arsys/forms/itsmapp.standardbank.co.za/SRS:ServiceRequestConsole/?mode=submit&F303900000=4&F303900900=SRH2230888367AOPO2TIP1WPF2GDNM&F303906700=0&F303902000=0&F303902100=0',

    //Generic App Routing URLs
    ewis: '/EWIS',
    rdarr: '/RDARR',
    riskAppetite: '/RiskAppetite',
    riskCulture: '/RiskCulture',
    indicatorMicroservice: '/Indicators',

    // Bridges
    rdarrBridge: '/go/rdarr',

    // Admin Routes
    admin: '/Admin',
    adminUsers: '/Admin/Users/:id*',
    adminUser: '/Admin/Users/:id',
    adminSystems: '/Admin/Systems/:id*',
    adminSystem: '/Admin/Systems/:id',
};
